import { Component, OnInit } from '@angular/core';
import { InvoiceService } from 'app/shared/services/invoice.service';
import { ExpenseService } from 'app/shared/services/expense.service';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { CompanyProfileService } from 'app/shared/services/company-profile.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import * as moment from 'moment';
import * as XLSX from 'xlsx'; 
import { NbThemeService } from '@nebular/theme';

@Component({
  selector: 'app-income-statement',
  templateUrl: './income-statement.component.html',
  styleUrls: ['./income-statement.component.css']
})
export class IncomeStatementComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>

  fromDate : Date;
  toDate : Date;
  isDark: boolean = false;
 
  invoiceLst : any[]=[];
  filteredInvoiceList : any[]=[];
  expenseLst : any[]=[];
  filteredExpenseList : any[]=[];
  companyName : string = null;

  salesIncome : number;
  costOfSales : number;
  grossProfit : number;
  adminExp : number;
  distributionExp : number;
  marketingExp : number;
  salaryExp: number;
  financeExp : number;
  otherExp : number;
  totalExp : number;
  netProfit : number;




  constructor(
              private invoiceService  : InvoiceService , 
              private expenseService : ExpenseService, 
              private router : Router, 
              private themeService: NbThemeService,
              private companyProfileService: CompanyProfileService,
             )
              {
                this.datepickerConfig = Object.assign({},
                {   
                  showWeekNumbers:false,
                  dateInputFormat : 'YYYY-MM-DD'
                });

              }

    ngOnInit() {
      this.initPNLVariables();
      this.getAllInvoices();
      this.getAllExpBreakup(); 
      this. getCompanyDetails(); 
      
      this.themeService.onThemeChange()
      .subscribe(themeName =>{
           this.isDark  = themeName.name ==='dark' ? true : false;
         });
    }

    initPNLVariables(){
      this.salesIncome = 0.00;
      this.costOfSales = 0.00;
      this.grossProfit = 0.00;
      this.adminExp = 0.00;
      this.distributionExp = 0.00;
      this.marketingExp = 0.00;
      this.salaryExp= 0.00;
      this.financeExp = 0.00;
      this.otherExp = 0.00;
      this.totalExp = 0.00;
      this.netProfit = 0.00;

    }

    // initPNLVariablesValues(){
    //   this.salesIncome = 123500.00;
    //   this.costOfSales = 65200.00;
    //   this.grossProfit = 58300.00;
    //   this.adminExp = 12300.00;
    //   this.distributionExp = 8000.00;
    //   this.marketingExp = 2500.00;
    //   this.salaryExp= 15000.00;
    //   this.financeExp = 800.00;
    //   this.otherExp = 3000.00;
    //   this.totalExp = 41600.00;
    //   this.netProfit = 16700.00;

    // }

    getCompanyDetails(){
      this.companyProfileService.getCompanyDetails()
      .subscribe(
        (data) =>{
                  this.companyName = data.CompanyName;
                 
                  },
        (err) => {
          if(err instanceof HttpErrorResponse){                 
            if(err.status == 401){
              this.router.navigate(['/login']);
            }
          }
          console.log(err);
        }
      );
    
    }

    getAllInvoices(){
      this.invoiceService.getAll()
       .subscribe(
          (data) => {
                    this.invoiceLst = data;  
                    this.filteredInvoiceList =  this.invoiceLst ;                           
                    },
         (err) => 
                  {
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  });          
       }
  
 
    getAllExpBreakup(){
    this.expenseService.getAllExpBreakup()
     .subscribe(
        (data) => {
                  this.expenseLst = data;  
                  this.filteredExpenseList =   this.expenseLst;                           
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });          
     }

     getTotal(){
      return this.filteredExpenseList.map(data=>data.Amount).reduce((acc,value)=>acc + value,0);
    }
    

      viewBtnClicked(){
        this.initPNLVariables();
        if(this.fromDate && this.toDate){
            var startDate =moment(this.fromDate).format("YYYY-MM-DD");
            var endDate =moment(this.toDate).format("YYYY-MM-DD");

            this.filteredInvoiceList = this.invoiceLst.filter(date => {
                var expDate = moment(date.InvoiceDate).format("YYYY-MM-DD");              
                return moment(expDate).isBetween(startDate, endDate,undefined,'[]');
                });
                
            this.filteredExpenseList = this.expenseLst.filter(data => {
                  var expDate = moment(data.ExpDate).format("YYYY-MM-DD");              
                  return moment(expDate).isBetween(startDate, endDate,undefined,'[]');               
                  });

           this.salesIncome= this.filteredInvoiceList.map(totalBal=>totalBal.GrandTotal).reduce((acc,value)=>acc + +value,0);
           this.costOfSales= this.filteredInvoiceList.map(totalBal=>totalBal.TotalCost).reduce((acc,value)=>acc + +value,0);
           this.grossProfit = this.salesIncome - this.costOfSales;

           for(let i =0; i < this.filteredExpenseList.length;i++){
              if(this.filteredExpenseList[i].ExpCategory ==='Administration'){
                  this.adminExp += +this.filteredExpenseList[i].Amount;
              }else if(this.filteredExpenseList[i].ExpCategory ==='Repair and Maintenance'){
                this.distributionExp += +this.filteredExpenseList[i].Amount;
              }else if(this.filteredExpenseList[i].ExpCategory ==='Outside Vehicle Rent'){
                this.marketingExp += +this.filteredExpenseList[i].Amount;
              }else if(this.filteredExpenseList[i].ExpCategory ==='Salary'){
                this.salaryExp += +this.filteredExpenseList[i].Amount;
              }else if(this.filteredExpenseList[i].ExpCategory ==='Finance'){
                this.financeExp += +this.filteredExpenseList[i].Amount;
              }else if(this.filteredExpenseList[i].ExpCategory ==='Other'){
                this.otherExp += +this.filteredExpenseList[i].Amount;  
              }

           }


           this.totalExp = this.adminExp + this.distributionExp + this.marketingExp +
                            this.salaryExp + this.financeExp + this.otherExp;

           this.netProfit = this.grossProfit - this.totalExp;

        }

    
        
      }


     clearBtnClicked(){
      this.fromDate = null;
      this.toDate = null;
      this.initPNLVariables();
     }

     exportexcel(): void 
     {
        /* table id is passed over here */   
        let element = document.getElementById('pnlReport'); 
        const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
        /* save to file */
        XLSX.writeFile(wb, 'Profit and Loss Statement.xlsx');
       
     }

    

}
